module.exports = __webpack_public_path__ + "static/CatamaranThin100Latin.8e9c9a34.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/styles/fonts/CatamaranThin100Latin.woff2
// module id = 95
// module chunks = 50294634969860 261391122289601 277288064929247